import { LegalDocument } from '@/components/legal/LegalDocument';
import { PRIVACY_SECTIONS, PRIVACY_TITLE, PRIVACY_DATE } from '@/legal/privacyPolicy';

export default function PrivacyPolicy() {
  return <LegalDocument title={PRIVACY_TITLE} subtitle={PRIVACY_DATE} sections={PRIVACY_SECTIONS} testId="privacy-policy-page" />;
}
